import React from 'react';
import { checkIncludeProfiles } from 'src/app/utils/getAuthorityLevel';
import Error404 from 'src/app/components/Error404';
import WeekChallengeSidebar from './WeekChallengeSidebar';
import WeekChallengeContent from './WeekChallengeContent';

export default function CreateWeekChallenge() {
  const isAdmin = !checkIncludeProfiles({ only: ['student'] });

  if (!isAdmin) return <Error404 />;

  return (
    <div className="main-screen">
      <WeekChallengeSidebar />

      <div className="main-content main-content--admin-layout">
        <WeekChallengeContent />
      </div>
    </div>
  );
}
